import React from 'react';
import { node, string, bool, object } from 'prop-types';
import { any, pathEq } from 'ramda';
import Grid from '@material-ui/core/Grid';
import { useConnect } from './hooks';

const Page = ({ id, testId, children, name, justify = 'center', direction, fullHeight, style }) => {
  const { isDownsized } = useConnect();

  const isFooter = () => any(pathEq(['type', 'displayName'], 'Footer'), children);

  return (
    <Grid
      id={id}
      data-testid={testId}
      container
      style={{
        maxWidth: '700px',
        margin: '0 auto',
        ...(isFooter()
          ? {
            padding: isDownsized ? '8px' : '25px',
            minHeight: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'flex-start',
          }
          : {
            padding: isDownsized ? '12px 8px 0px 8px' : '25px 16px 0px 16px',
          }),
        ...(fullHeight && { height: '100%' }),
        ...style,
      }}
      name={name}
      justify={justify}
      direction={direction}
    >
      {children}
    </Grid>
  );
};

Page.propTypes = {
  id: string,
  testId: string,
  children: node,
  name: string.isRequired,
  justify: string,
  direction: string,
  fullHeight: bool,
  style: object,
};

export default Page;
